import { supabase, isSupabaseAvailable } from './supabaseClient';

export interface AdminMetrics {
  totalClinicians: number;
  activeClinicians: number;
  totalPatients: number;
  totalTests: number;
  totalEvolutivos: number;
  testsThisMonth: number;
  evolutivosThisMonth: number;
}

export interface SuperAdminMetrics {
  totalUsers: number;
  totalClinicians: number;
  totalAdmins: number;
  totalSuperadmins: number;
  totalTests: number;
  totalPatients: number;
  totalEvolutivos: number;
  subscriptionCounts: Record<string, number>;
  activeSubscriptionCounts: Record<string, number>;
  activeSubscriptions: number;
  testsThisMonth: number;
  evolutivosThisMonth: number;
  mrr: number;
  arr: number;
  arpu: number;
  paidSubscribers: number;
  mrrByTier: Record<string, number>;
  aiTestsTotal: number;
  aiTestsThisMonth: number;
  aiEvolutivosTotal: number;
  aiEvolutivosThisMonth: number;
}

export const getAdminMetrics = async (): Promise<AdminMetrics | null> => {
  if (!isSupabaseAvailable()) {
    console.warn('Supabase not available, cannot fetch admin metrics');
    return null;
  }

  try {
    const { data: { session } } = await supabase!.auth.getSession();
    if (!session) {
      console.warn('No active session, cannot fetch admin metrics');
      return null;
    }

    const { data, error } = await supabase!.functions.invoke('get-admin-metrics', {
      headers: {
        Authorization: `Bearer ${session.access_token}`,
      },
    });

    if (error) {
      console.error('Error fetching admin metrics:', error);
      return null;
    }

    return data as AdminMetrics;
  } catch (err) {
    console.error('Failed to fetch admin metrics:', err);
    return null;
  }
};

export const getSuperAdminMetrics = async (): Promise<SuperAdminMetrics | null> => {
  if (!isSupabaseAvailable()) {
    console.warn('Supabase not available, cannot fetch superadmin metrics');
    return null;
  }

  try {
    const { data: { session } } = await supabase!.auth.getSession();
    if (!session) {
      console.warn('No active session, cannot fetch superadmin metrics');
      return null;
    }

    const { data, error } = await supabase!.functions.invoke('get-superadmin-metrics', {
      headers: {
        Authorization: `Bearer ${session.access_token}`,
      },
    });

    if (error) {
      console.error('Error fetching superadmin metrics:', error);
      return null;
    }

    return data as SuperAdminMetrics;
  } catch (err) {
    console.error('Failed to fetch superadmin metrics:', err);
    return null;
  }
};
